import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-rename-model',
  templateUrl: './rename-model.component.html',
  styleUrls: ['./rename-model.component.css']
})
export class RenameModelComponent implements OnInit {

  modelName = "";
  modeler;
  nameExist = true;
  constructor(public dialogRef: MatDialogRef<RenameModelComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
      dialogRef.disableClose = true;
  }

  ngOnInit(): void {
    this.modelName = this.data.name;
    this.modeler = this.data.entireModeler;
  }

  validateKey(event) {
    let latest = event.target.value;
    let nameExisiting;
    nameExisiting = this.data.modeler.diagrams[0].plane.planeElement.filter((m) => { return m.bpmnElement.$attrs.modelUniqueId == latest });
    this.nameExist = nameExisiting.length > 0;
  }

  saveWorkflow() {
    this.dialogRef.close(this.modelName);
  }

  onCancelClick(): void {
    this.dialogRef.close(false);
  }

}
